import { render, staticRenderFns } from "./ToolSearch.vue?vue&type=template&id=2cc38f83"
import script from "./ToolSearch.vue?vue&type=script&setup=true&lang=ts"
export * from "./ToolSearch.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports